import React from 'react'

export type UserType = 'local' | 'ldap' | 'oidc'

interface TypeLabelProps {
  type: UserType | string
  text: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const getTypeStyles = (type: string) => {
  switch (type) {
    case 'local':
      return 'bg-gray-100 text-gray-800 border border-gray-200'
    case 'ldap':
      return 'bg-yellow-100 text-yellow-800 border border-yellow-200'
    case 'oidc':
      return 'bg-orange-100 text-orange-800 border border-orange-200'
    default:
      return 'bg-gray-100 text-gray-800 border border-gray-200'
  }
}

const getSizeClasses = (size: 'sm' | 'md' | 'lg') => {
  switch (size) {
    case 'sm':
      return 'px-2 py-0.5 text-xs'
    case 'md':
      return 'px-3 py-1 text-sm'
    case 'lg':
      return 'px-4 py-1.5 text-base'
    default:
      return 'px-3 py-1 text-sm'
  }
}

export default function TypeLabel({ type, text, size = 'md', className = '' }: TypeLabelProps) {
  const typeStyles = getTypeStyles(type)
  const sizeClasses = getSizeClasses(size)

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${typeStyles} ${sizeClasses} ${className}`}>
      {text}
    </span>
  )
}